import {
  EntrancePlantDetailDTO,
  EPDeviceTypeEnum,
  GateMessageDTO,
} from '@/../client-generator/generated-clients/plants';
import { mapState } from 'vuex';
import { Options, Vue } from 'vue-class-component';
import MessageItem from './MessageItem/MessageItem.vue';
import DialogAddEditMessage from './DialogAddEditMessage/DialogAddEditMessage.vue';
import plantsClient from '@/core/services/plants';
import { SET_APP_LOADING } from '@/core/store/action-types';

enum MessageTab {
  active = 'active',
  expired = 'expired',
}

@Options({
  name: 'EntrancePlantMessages',
  computed: {
    ...mapState(['currentEntrancePlant']),
  },
  components: { DialogAddEditMessage, MessageItem },
  emits: ['update-list'],
})
export default class EntrancePlantMessages extends Vue {
  MessagesTab = MessageTab;
  currentEntrancePlant!: EntrancePlantDetailDTO;
  tabSelected: MessageTab = MessageTab.active;
  isVisibleAddEditMessage = false;
  messageToEdit: GateMessageDTO | null = null;

  async mounted() {}

  get backLink() {
    return {
      name: 'page-entranceplant-dashboard',
      params: this.$route.params,
    };
  }

  get messages() {
    return this.currentEntrancePlant.gateMessages;
  }

  get messagesList() {
    let messagesFilteredList: GateMessageDTO[] = [];
    const today = new Date();

    if (this.messages) {
      switch (this.tabSelected) {
        case MessageTab.active:
          messagesFilteredList = this.messages.filter(
            (message) =>
              !message.durationUntil ||
              this.dateAdjust(message.durationUntil).getTime() >= today.getTime()
          );
          break;

        case MessageTab.expired:
          messagesFilteredList = this.messages.filter(
            (message) =>
              message.durationUntil &&
              this.dateAdjust(message.durationUntil).getTime() < today.getTime()
          );
          break;
      }
    }

    return messagesFilteredList;
  }

  get gatesWithPE() {
    return this.currentEntrancePlant.gates?.filter((gate) => gate.devices?.some(
      (device) => device.type === EPDeviceTypeEnum.Linea5000
      ))
  }

  handleTabClick(event: { index: number }) {
    this.setSelectionCriteria(
      event.index === 0 ? MessageTab.active : MessageTab.expired
    );
  }

  setSelectionCriteria(selectionCriteria: MessageTab) {
    this.tabSelected = selectionCriteria;
  }

  toggleAddEditMessage(messageToEdit?: GateMessageDTO) {
    this.messageToEdit = messageToEdit ?? null;
    this.isVisibleAddEditMessage = !this.isVisibleAddEditMessage;
  }

  handleUpdateList() {
    this.$emit('update-list');
  }

  dateAdjust(date: Date) {
    return new Date(date.toISOString().split('Z')[0])
  }

  async handleDeleteMessage(messageId: string) {
    this.$store.dispatch(SET_APP_LOADING, true);
    try {
      await plantsClient.gatemessageDELETE(
        this.currentEntrancePlant.desktopId as number,
        messageId
      );

      this.$emit('update-list');
      setTimeout(() => {
        this.$toast.add({
          severity: 'success',
          summary: this.$t('AppResourceEP.GateMessageBannerDeleted'),
          closable: false,
          life: 3000,
        });
      }, 1500);
    } catch {
      this.$toast.add({
        severity: 'error',
        summary: this.$t('general.operationError'),
        closable: true,
        life: 3000,
      });
    } finally {
      this.$store.dispatch(SET_APP_LOADING, false);
    }
  }
}
